var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/axios';
import kendoDatatableParams from '../../../helpers/kendoDatatableParams';
import { apiInternalSprinklerSampleSubmissionsPath, prepopulateApiInternalSprinklerSampleSubmissionsPath, toggleStatusApiInternalSprinklerSampleSubmissionPath, generateKitNumberApiInternalSprinklerSampleSubmissionsPath, apiInternalKitOrdersPath, prepopulateApiInternalKitOrdersPath, statusApiInternalKitOrderPath } from '../../../routes';
export function getSprinklerSampling(params) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        try {
            const url = params.buildingId
                ? apiInternalSprinklerSampleSubmissionsPath({ building_id: params.buildingId })
                : apiInternalSprinklerSampleSubmissionsPath();
            const response = yield api.get(url, {
                params: kendoDatatableParams({
                    page: params.page,
                    sort: params.sort,
                    filters: params.filters,
                    search: params.search
                })
            });
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error fetching sprinkler sampling data:', error);
            return {
                error: {
                    message: ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || error.message || 'Failed to fetch sprinkler sampling data',
                    errors: (_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.errors
                }
            };
        }
    });
}
export function getPrepopulateData(buildingId) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        try {
            const response = yield api.get(prepopulateApiInternalSprinklerSampleSubmissionsPath({ building_id: buildingId }));
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error fetching prepopulate data:', error);
            return {
                error: {
                    message: ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || error.message || 'Failed to load form defaults',
                    errors: (_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.errors
                }
            };
        }
    });
}
export function createSprinklerSampleSubmission(buildingId, formData) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        try {
            yield api.post(apiInternalSprinklerSampleSubmissionsPath({ building_id: buildingId }), {
                sprinkler_sample_submission: formData
            });
            return {
                data: undefined
            };
        }
        catch (error) {
            console.error('Error creating sprinkler sample submission:', error);
            return {
                error: {
                    message: ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || error.message || 'Failed to submit form',
                    errors: (_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.errors
                }
            };
        }
    });
}
export function toggleSprinklerSampleStatus(submissionId) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        try {
            const response = yield api.patch(toggleStatusApiInternalSprinklerSampleSubmissionPath({ id: submissionId }));
            if (!response.data || !response.data.success) {
                throw new Error('Failed to toggle status');
            }
            return {
                data: { status: response.data.status }
            };
        }
        catch (error) {
            return {
                error: {
                    message: ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || error.message || 'Failed to update status',
                    errors: (_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.errors
                }
            };
        }
    });
}
export function generateKitNumber(buildingId) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e;
        try {
            const response = yield api.get(generateKitNumberApiInternalSprinklerSampleSubmissionsPath({ building_id: buildingId }));
            if (!((_a = response.data) === null || _a === void 0 ? void 0 : _a.kit_number)) {
                throw new Error('No kit number received from server');
            }
            return {
                data: { kitNumber: response.data.kit_number }
            };
        }
        catch (error) {
            return {
                error: {
                    message: ((_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.error) || error.message || 'Failed to generate kit number',
                    errors: (_e = (_d = error.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.errors
                }
            };
        }
    });
}
export function createKitOrder(buildingId, formData) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        try {
            yield api.post(apiInternalKitOrdersPath({ building_id: buildingId }), {
                kit_order: formData
            });
            return {
                data: undefined
            };
        }
        catch (error) {
            console.error('Error creating kit order:', error);
            return {
                error: {
                    message: ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || error.message || 'Failed to submit kit order',
                    errors: (_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.errors
                }
            };
        }
    });
}
export function getKitOrders(params) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        try {
            const response = yield api.get(apiInternalKitOrdersPath(), {
                params: kendoDatatableParams({
                    page: params.page,
                    sort: params.sort,
                    filters: params.filters,
                    search: params.search
                })
            });
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return { data: response.data };
        }
        catch (error) {
            console.error('Error fetching kit orders:', error);
            return {
                error: {
                    message: ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || error.message || 'Failed to fetch kit orders',
                    errors: (_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.errors
                }
            };
        }
    });
}
export function updateKitOrderStatus(id, status) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e;
        try {
            const response = yield api.patch(statusApiInternalKitOrderPath({ id }), { status });
            if (!((_a = response.data) === null || _a === void 0 ? void 0 : _a.success)) {
                throw new Error('Failed to update status');
            }
            return { data: { status: response.data.status } };
        }
        catch (error) {
            console.error('Error updating kit order status:', error);
            return {
                error: {
                    message: ((_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.error) || error.message || 'Failed to update status',
                    errors: (_e = (_d = error.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.errors
                }
            };
        }
    });
}
export function getKitOrderPrepopulateData(buildingId) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        try {
            const response = yield api.get(prepopulateApiInternalKitOrdersPath({ building_id: buildingId }));
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error fetching kit order prepopulate data:', error);
            return {
                error: {
                    message: ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || error.message || 'Failed to load form defaults',
                    errors: (_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.errors
                }
            };
        }
    });
}
